module.exports = __webpack_public_path__ + "static/media/8.77e74583.png";